var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"container"},[_c('kion-title',[_vm._t("title")],2),_c('h2',{staticClass:"subtitle"},[_vm._t("subtitle")],2),_c('div',{class:['main',
   {
    'full-space': _vm.fullSpace
   }
  ]},[_vm._t("default")],2),_c('kion-copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }